module.exports = __webpack_public_path__ + "static/media/is_walking_area.6773ed5c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/is_walking_area.svg
// module id = 1432
// module chunks = 0